"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.unshiftRange = exports.shiftRange = void 0;
function shiftRange(curRange, { pageShift, pageCount }) {
    if (curRange === '-1')
        return `${pageShift}-${pageShift + pageCount - 1}`;
    return curRange.replace(/(\d+)/gi, (_m, i) => (parseInt(i, 10) + pageShift).toString());
}
exports.shiftRange = shiftRange;
function unshiftRange(shiftedRange, { pageShift, pageCount }) {
    const unshiftedRange = shiftedRange.replace(/(\d+)/gi, (_m, i) => (parseInt(i, 10) - pageShift).toString());
    const parts = unshiftedRange.split('-');
    // n-m
    if (parts.length === 2 && parseInt(parts[1], 10) - parseInt(parts[0], 10) === pageCount - 1)
        return '-1';
    return unshiftedRange;
    // n,m,...
    // n-m,j, k
}
exports.unshiftRange = unshiftRange;
//# sourceMappingURL=attrRanges.js.map